namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailFormularSk extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GFormularSkReadDto;
        private newRecord: boolean;
        private detailObj: DetailFormularSkObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailFormularSkObj());
            this.detailObj.createBase({
                contentName: "detailFormularSk",
                contentCaption: "jres:32131108",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            tabs.push(this.detailObj.getFilesFieldsData())
            tabs.push(this.detailObj.getPolozkyFormulare())
            tabs.push(this.detailObj.getMapovanePolozkyFormulare())
            if (this.newRecord == false) 
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            groups.push(this.detailObj.getGroupFilesFieldsData());
            groups.push(this.detailObj.getPolozkyFormulareGroup());
            groups.push(this.detailObj.getMapovanePolozkyFormulareGroup())
            if (this.newRecord == false) 
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailFormularSk", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        onClose() {
            this.detailObj.removeFiles();
        }
    }


    export class DetailFormularSkObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GFormularSkReadDto> {
        private povolPrizImportExport: boolean;
        private povolSlozka: boolean;
        private povolFormularDolozky: boolean;
        private povolPevnaHodnota: boolean;
        private serviceContent: GContent;
        private guids: string[];
        private guidsXml: string[];
        private oldIxsUlo: string[];
        private newIxsUlo: string[];

        private gridPolozkyFormulare: JQuery<HTMLElement>;
        private gridMapovanePolozkyFormulare: JQuery<HTMLElement>;

        private editPolozka: number;

        private getSrv(): GContent {
            if (!this.serviceContent)
                this.serviceContent = this.cnt.createServiceContent("Gordic.Adm.WebControls.DetailFormularSk")
            return this.serviceContent;
        }

        private fieldsData: Gordic.Adm.WebControls.FormFileDto[] = [
			{ modelValue: "ixb_html_form", caption: "jres:33000067", changeValue: false, allowExtension: ".html"}, //RC 33000067 : Prázdny html formulár
			{ modelValue: "ixb_posp", caption: "jres:33000068", changeValue: false, allowExtension: ".xml" }, //RC 33000068 : POSP
			{ modelValue: "ixb_xml_dct", caption: "jres:33000069", changeValue: false, allowExtension: ".xml,.dct" }, //RC 33000069 : Xml súbor slovnika (dictionary)
			{ modelValue: "ixb_xml_edd", caption: "jres:33000070", changeValue: false, allowExtension: ".xml" }, //RC 33000070 : Xml metadáta na predvyplnenie formulára
			{ modelValue: "ixb_xml_edoc", caption: "jres:33000071", changeValue: false, allowExtension: ".xml" }, //RC 33000071 : eDoc (elektronický dokument) prázdne xml
			{ modelValue: "ixb_xml_map", caption: "jres:33000072", changeValue: false, allowExtension: ".xml" }, //RC 33000072 : Mapovacie xml medzi natívnym xml a eDoc
			{ modelValue: "ixb_xml_mtd", caption: "jres:33000073", changeValue: false, allowExtension: ".xml" }, //RC 33000073 : Xml súbor s metadátami formulára
			{ modelValue: "ixb_xml_nat", caption: "jres:33000074", changeValue: false, allowExtension: ".xml" }, //RC 33000074 : Natívne prázdne xml, ktoré reprezentuje natívne xml, ktoré vypadne z vyplneného formulára
			{ modelValue: "ixb_xsd_edoc", caption: "jres:33000075", changeValue: false, allowExtension: ".xsd" }, //RC 33000075 : XSD definícia dátovej štruktúry
			{ modelValue: "ixb_xsd_nat", caption: "jres:33000076", changeValue: false, allowExtension: ".xsd"  }, //RC 33000076 : Xsd natívneho xml
			{ modelValue: "ixb_xsl_fo", caption: "jres:33000077", changeValue: false, allowExtension: ".xsl" }, //RC 33000077 : Xsl fo transformácia. Slúži na použitie pri zobrazení do pdf
			{ modelValue: "ixb_xslt_default", caption: "jres:33000078", changeValue: false, allowExtension: ".xslt" }, //RC 33000078 : Xslt html transformácia na zobrazenie formulára
			{ modelValue: "ixb_xslt_edoc_nat", caption: "jres:33000079", changeValue: false, allowExtension: ".xslt" }, //RC 33000079 : Elektronický nativní dokument
			{ modelValue: "ixb_xslt_html", caption: "jres:33000080", changeValue: false, allowExtension: ".xslt" }, //RC 33000080 : Xslt transformácia z eDoc xml do html
			{ modelValue: "ixb_xslt_nat_edoc", caption: "jres:33000081", changeValue: false, allowExtension: ".xslt" }, //RC 33000081 : Transformácia z eDoc xml do natívneho xml
			{ modelValue: "ixb_xslt_ro", caption: "jres:33000082", changeValue: false, allowExtension: ".xslt" }, //RC 33000082 : Xslt html transformácia na zobrazenie formulára v režime readonly
			{ modelValue: "ixb_xslt_sb", caption: "jres:33000083", changeValue: false, allowExtension: ".xslt" }, //RC 33000083 : Xslt transformácia do txt na zobrazenie pre podpisovač.
		]

        create() {
            this.guids = [];
            this.oldIxsUlo = [];
            this.newIxsUlo = [];
            this.guidsXml = [];
        }

        removeFiles() {
            this.getSrv().fire("DeleteGuids", { guids: this.guids });
            this.getSrv().fire("DeleteGuids", { guids: this.guidsXml });
            if (this.editMode == true)
                this.getSrv().fire("DeleteFromEle", { ixsFiles: this.oldIxsUlo });
        }

        textPopis(): string | undefined | null {
            return this.data["nazev"]
        }

        setSxsDetail(): string {
            return this.data.ixs_fsk ? this.data.ixs_fsk.toString() : "";
        }

        saveData(data: Gordic.AdmIsl.Interface.GFormularSkDto, close: boolean) {
            this.getDataFromFields(data);
            this.getPolozkyFormulareData(data);
            this.getPolozkyFormulareMapovani(data);
            var nenalezenePolozky = this.validatePolozkyMapovani(data);
            if (nenalezenePolozky.length > 0) {
                this.cnt.dialogs.confirm("jres:33000045", "jres:33000688".format(nenalezenePolozky.join(", "))).on("yes", () => { //RC 33000688 : V položkách formuláře nebyly nalezeny tyto mapované položky:<br /><b>{0}</b><br/><br />Je možné, že formulář nebude pracovat správně. Přejete si i přesto pokračovat?
                    this.saveDataIsl(data, close);
                })
            } else {
                this.saveDataIsl(data, close);
            }
        }

        private validatePolozkyMapovani(data: Gordic.AdmIsl.Interface.GFormularSkDto): string[] {
            if (data.polozkyFormulare && data.mapovanePolozkyFormulare) {
                var polozkyFormulare = data.polozkyFormulare.map((item) => item.sloupec)
                var mapovanePolozky = data.mapovanePolozkyFormulare.map((item) => item.vyraz)
                var nenalezenePolozky: string[] = [];
                mapovanePolozky.forEach((item) => {
                    if (polozkyFormulare.indexOf(item) == -1) {
                        if (item)
                           nenalezenePolozky.push(item);
                    }
                })
                return nenalezenePolozky;
            } else
                return [];
        }

        private saveDataIsl(data: Gordic.AdmIsl.Interface.GFormularSkDto, close: boolean) {
            (this.cnt.isl.FormularSk.upsert({ data: data }).get() as any).done((output) => {
                Gordic.Data.readerCache.clearCache("Gordic.ControlsLogic.Client.GReaderWflsfsk");
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    });
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailFormularSk", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.FormularSk.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.nazev) ? this.data.nazev : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                "actCheckExtensionDialog",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actCloseDialog: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        $.content(ev.target).close();
                    }
                },
                actCheckExtensionDialog: {
                    caption: "jres:33000977", //RC 33000977 : Nastavení
                    icon: "gi-settings",
                    run: (ev, ctx) => {
                        this.formSettings();
                    }
                },
                // Formuláře
                actOpenDetailFile: {
                    caption: "jres:33000601", //RC 33000601 : Editovat soubor
                    captionVisible: "never",
                    icon: "gi-pencil",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.openDialogFile(ctx);
                    }
                },
                actDownloadFile: {
                    caption: "jres:33000602", //RC 33000602 : Stáhnout soubor
                    captionVisible: "never",
                    icon: "gi-download",
                    run: (ev, ctx) => {
                        this.downloadFile(ctx);
                    }
                },
                actDeleteFromField: {
                    caption: "jres:33000603", //RC 33000603 : Vymazat pole
                    captionVisible: "never",
                    icon: "gi-window-close",
                    enabled: false,
                    run: (ev, ctx) => {
                        this.removeFile(ctx)
                    }
                },
                actUpsvEmptyField: {
                    caption: "jres:33000971", //RC 33000971 : Nastavit nedostupnost ve webové službě
                    captionVisible: "never",
                    icon: "gi-inactive",
                    enabled: false, 
                    run: (ev, ctx) => {
                        this.upsvEmptyFile(ctx)
                    }
                },
                // Položky formuláře
                actAddPolozka: {
                    caption: "jres:32000121",
                    enabled: false,
                    icon: "gi-plus",
                    run: (ev, ctx) => {
                        this.addPolozkaFormulare();
                    }
                },
                actRemovePolozka: {
                    caption: "jres:33000434",
                    enabled: false,
                    icon: "gi-bin",
                    run: (ev, ctx) => {
                        this.removePolozkaFormulare();
                    }
                },
                actGetDataFromXml: {
                    caption: "jres:33000741", //RC 33000741 : Načíst položky z XML
                    tooltip: "jres:33000742", //RC 33000742 : Načte všechny dostupné xpath ze souboru, včetně ukázkových hodnot
                    enabled: false,
                    icon: "gi-accept",
                    run: (ev, ctx) => {
                        this.dialogFileXml();
                    }
                },
                actGetDataFromXmlOk: {
                    caption: "jres:33000243", 
                    run: (ev, ctx) => {
                        this.dialogFileXmlOk(ev);
                    }
                },
                actGetDataFromXmlEmpty: {
                    caption: "jres:33000749", //RC 33000749 : Načíst položky z prázdného XML 
                    tooltip: "jres:33000750", //RC 33000750 : Pokud je nahrán soubor edoc (elektronický dokument) prázdne xml lze načíst data z něj, bez ukázkových hodnot.
                    enabled: false,
                    icon: "gi-accept",
                    run: (ev, ctx) => {
                        this.getDataFromXmlEmpty();
                    }
                },
                // Mapované položky fomruláře 
                actAddMapovanaPolozka: {
                    caption: "jres:32000121",
                    enabled: false,
                    icon: "gi-plus",
                    run: (ev, ctx) => {
                        this.addMapovanaPolozka();
                    }
                },
                actRemoveMapovanaPolozka: {
                    caption: "jres:33000434",
                    enabled: false,
                    icon: "gi-bin",
                    run: (ev, ctx) => {
                        this.removeMapovanaPolozka();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {
            this.cnt.actions.actOpenDetailFile?.update({ enabled: editMode == true })
            this.cnt.actions.actDeleteFromField?.update({ enabled: editMode == true })
            this.cnt.actions.actUpsvEmptyField?.update({ enabled: editMode == true })
            this.cnt.findForms("file-fields").findFields().gfield("disable");
            // Tab polozky formulare
            this.cnt.actions.actAddPolozka?.update({ enabled: editMode == true })
            var activeRow = this.gridPolozkyFormulare.ggrid("activeRow");
            this.cnt.actions.actRemovePolozka?.update({ enabled: (activeRow != null && activeRow != undefined) ? editMode == true : false })
            this.cnt.actions.actGetDataFromXml?.update({ enabled: editMode == true })
            this.cnt.actions.actGetDataFromXmlEmpty?.update({ enabled: editMode == true && (this.data.ixb_xml_edoc != null && this.data.ixb_xml_edoc != undefined) })
            // Tab mapovane polozky
            this.cnt.actions.actAddMapovanaPolozka?.update({ enabled: editMode == true })
            var activeRow2 = this.gridMapovanePolozkyFormulare.ggrid("activeRow");
            this.cnt.actions.actRemoveMapovanaPolozka?.update({ enabled: (activeRow2 != null && activeRow2 != undefined) ? editMode == true : false })
        }

        createForm() {
            this.MakeField("ixs_fsk");
            this.MakeField("eform_id");
            this.MakeField("eformversion");
            this.MakeField("nazev");
            this.MakeSelectField("typ_zarazeni", Gordic.Prefabs.Select.wflcfsk(), { model: "model.typ_zarazeni=value.typ_zarazeni" })
            if (this.povolSlozka)
                this.MakeSelectField("ixs_slo", Gordic.Prefabs.Select.admWflsssk(), { model: "model.ixs_slo=value.ixs_slo" })
            if (this.povolFormularDolozky)
                this.MakeSelectField("ixs_fsk_do", Gordic.Prefabs.Select.wflsfsk(), {
                    model: "model.ixs_fsk_do=value.ixs_fsk",
                    validators: [this.validateSameFormular()],
                    serverFilters: {
                        aktivita: [100, 300, 500, 600, 900]
                    }
                })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }

        private validateSameFormular(): Gordic.Validators.Base {
            return new Gordic.Validators.Base({
                stopping: true,
                message: "jres:33001018", //RC 33001018 : Fromulář doložky nesmí být stejný jako hlavní formulář.
                validate: (value, source) => {
                    if (value) {
                        if (this.options.newRecord == false) {
                            if (this.data.ixs_fsk?.trim() == value.ixs_fsk.trim())
                                return false;
                        }
                    }
                    return true;
                }
            })
        }

        getFilesFieldsData(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-files",
                    title: "jres:33000123",
                    opened: true,
                    locked: true,
                    group: { id: "_tab-files" }
                },
                init: (tab) => { this.createFormFiles(tab) }
            }
        }

        getGroupFilesFieldsData(): IGTabGroupOptions {
            return { id: "_tab-files", caption: "jres:33000123" }
        }

        getPolozkyFormulare(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-polozky-formulare",
                    title: "jres:33000672", //RC 33000672 : Položky formuláře
                    opened: true,
                    locked: true,
                    group: { id: "_tab-polozky-formulare" },
                    menuBar: [
                        {
                            action: this.cnt.actions.actGetDataFromXml,
                            favorite: true
                        },
                        {
                            action: this.cnt.actions.actGetDataFromXmlEmpty,
                            favorite: true
                        },
                        {
                            action: this.cnt.actions.actAddPolozka,
                            favorite: true
                        },
                        {
                            action: this.cnt.actions.actRemovePolozka,
                            favorite: true
                        }
                    ]
                },
                init: (tab) => { this.createGridFiles(tab) }
            }
        }

        getPolozkyFormulareGroup(): IGTabGroupOptions {
            return { id: "_tab-polozky-formulare", caption: "jres:33000672" }
        }

        getMapovanePolozkyFormulare(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-mapovane-polozky-formulare",
                    title: "jres:33000679", //RC 33000679 : Mapované položky 
                    opened: true,
                    locked: true,
                    group: { id: "_tab-mapovane-polozky-formulare" },
                    menuBar: [
                        {
                            action: this.cnt.actions.actAddMapovanaPolozka,
                            favorite: true
                        },
                        {
                            action: this.cnt.actions.actRemoveMapovanaPolozka,
                            favorite: true
                        }
                    ]
                },
                init: (tab) => { this.createGridMapovanePolozky(tab) }
            }
        }

        getMapovanePolozkyFormulareGroup(): IGTabGroupOptions {
            return { id: "_tab-mapovane-polozky-formulare", caption: "jres:33000679" }
        }

        // TAB Mapovane polozky

        private createGridMapovanePolozky(tab) {
            var gf = new Gordic.Data.GridFormat()
                .addTextColumn({
                    name: "ixs_vla_txt",
                    caption: "jres:29932128",
                    editor: {
                        widget: "gselectbox",
                        options: $.extend(Gordic.Prefabs.Select.ginsvla(), {
                            dropdown: true,
                            model: "model.ixs_vla=value.ixs_vla;model.ixs_vla_txt=value.nazev;model.kod=value.kod;model.kod_form=value.kod_form",
                            validators: [
                                new Gordic.Validators.Required({ stopping: true }),
                                this.createValidatorUniqueMap()
                            ]
                        }),
                    }
                })
            if (this.povolPrizImportExport) {
                gf.addBooleanColumn({
                    name: "priz_import",
                    caption: "jres:33000771", //RC 33000771 : Příznak importu
                    editor: {
                        widget: "gcheck",
                        options: {
                            initialValue: true,
                            model: function (op, dto, opt) {
                                switch (op) {
                                    case "apply":
                                        $(this).gfield("setValue", Object.keys(dto).length > 0 ? dto.priz_import == 1 : true)
                                        break;
                                    case "collect":
                                        dto.priz_import = $(this).gfield("getValue") == true ? 1 : 0;
                                        break;
                                }
                            }
                        }
                    }
                }).addBooleanColumn({
                    name: "priz_export",
                    caption: "jres:33000772", //RC 33000772 : Export
                    editor: {
                        widget: "gcheck",
                        options: {
                            initialValue: true,
                            model: function (op, dto, opt) {
                                switch (op) {
                                    case "apply":
                                        $(this).gfield("setValue", Object.keys(dto).length > 0 ? dto.priz_export == 1 : true)
                                        break;
                                    case "collect":
                                        dto.priz_export = $(this).gfield("getValue") == true ? 1 : 0;
                                        break;
                                }
                            }
                        }
                    }
                })
            }
            gf.addTextColumn({
                    name: "kod",
                    caption: "jres:29932129"
                })
                .addTextColumn({
                    name: "vyraz",
                    caption: "jres:33000680", //RC 33000680 : Položka formuláře
                    editor: {
                        widget: "gselectbox",
                        options: {
                            data: () => {
                                if (this.gridPolozkyFormulare != undefined)
                                    return this.gridPolozkyFormulare.ggrid("getView").getDataRows(false, "data")
                                else
                                    return (this.data.polozkyFormulare) ? this.data.polozkyFormulare : []
                            },
                            itemTemplate: "{sloupec}",
                            dropdown: true,
                            strict: true,
                            model: "model.vyraz=value.sloupec",
                            validators: [
                                new Gordic.Validators.Required({ stopping: true })
                            ]
                        }
                    }
                })
                .addTextColumn({
                    name: "poznamka",
                    caption: "jres:30029010",
                    editor: {
                        widget: "gstringbox",
                        options: {
                            model: "model.poznamka=value",
                            initialValue: ""
                        }
                    }
                })


            this.gridMapovanePolozkyFormulare = $("<div>").appendTo(tab).gautofit({ resizersOnTab: false }).ggrid({
                selection: (ev, ctx) => {
                    this.cnt.actions.actRemoveMapovanaPolozka?.update({ enabled: ctx.count == 0 ? false : this.editMode == true })
                },
                columns: gf
            }).ggridroweditor({
                beforeStart: (ev, info) => {
                    this.editPolozka = info.view.getDataRows(false, "data").indexOf(info.cellInfo.data)
                    if (this.editMode == false)
                        ev.preventDefault();
                },
                save: (data, ev) => {
                   
                }
            })
            if (this.data.mapovanePolozkyFormulare)
                this.gridMapovanePolozkyFormulare.ggrid("setData", this.data.mapovanePolozkyFormulare);
        }

        private addMapovanaPolozka() {
            this.gridMapovanePolozkyFormulare.ggridroweditor("addRow");
        }

        private removeMapovanaPolozka() {
            var activeRow = this.gridMapovanePolozkyFormulare.ggrid("activeRow");
            if (activeRow != null && activeRow != undefined) {
                var view = this.gridMapovanePolozkyFormulare.ggrid("getView");
                view.updateData(activeRow, "delete");
                this.gridMapovanePolozkyFormulare.ggrid("setData", view);
            }
        }

        private getPolozkyFormulareMapovani(data: Gordic.AdmIsl.Interface.GFormularSkDto) {
            var view = this.gridMapovanePolozkyFormulare.ggrid("getView");
            data.mapovanePolozkyFormulare = view.getDataRows(false, "data").map((item) => ({
                ixs_stv: item["ixs_vla"],
                ixs_vla: item["ixs_vla"],
                vyraz: item["vyraz"],
                poznamka: item["poznamka"],
                kod_form: item["kod_form"],
                priz_import: item["priz_import"] != null && item["priz_import"] != undefined ? item["priz_import"] : 1,
                priz_export: item["priz_export"] != null && item["priz_export"] != undefined ? item["priz_export"] : 1
            }));
            if (data.mapovanePolozkyFormulare == null || data.mapovanePolozkyFormulare == undefined)
                data.mapovanePolozkyFormulare = [];
        }

        private createValidatorUniqueMap() {
            return new Gordic.Validators.Base({
                stopping: true,
                message: "jres:33000677", //RC 33000677 : Položka musí být na formuláři unikátní.
                validate: (value, source) => {
                    var currentData = this.gridMapovanePolozkyFormulare.ggrid("getView").getDataRows(false, "data");
                    var polozky = currentData.map((item) => item.ixs_vla)
                    if (this.editPolozka != -1)
                        polozky.splice(this.editPolozka, 1);
                    return polozky.filter(arr => { return arr == value["ixs_vla"] }).length == 0
                }
            })
        }

        // TAB Polozky

        private createGridFiles(tab) {
            this.gridPolozkyFormulare = $("<div>").appendTo(tab).gautofit({ resizersOnTab: false }).ggrid({
                selection: (ev, ctx) => {
                    this.cnt.actions.actRemovePolozka?.update({ enabled: ctx.count == 0 ? false : this.editMode == true })
                },
                columns: this.createGridFormatPolozkyFormulare()
            }).ggridroweditor({
                beforeStart: (ev, info) => {
                    this.editPolozka = info.view.getDataRows(false, "data").indexOf(info.cellInfo.data)
                    if (this.editMode == false)
                        ev.preventDefault();
                }
            })
            if (this.data.polozkyFormulare)
                this.gridPolozkyFormulare.ggrid("setData", this.data.polozkyFormulare);
        }

        private createGridFormatPolozkyFormulare(): Gordic.Data.GridFormat {
            var gf = new Gordic.Data.GridFormat()
                .addTextColumn({
                    name: "sloupec",
                    caption: "jres:33000673", //RC 33000673 : Položka formuláře
                    width: 100,
                    editor: {
                        widget: "gstringbox",
                        options: {
                            validators: [
                                new Gordic.Validators.Required({ stopping: true }),
                                new Gordic.Validators.RegExp({ pattern: "^[A-Za-z0-9_-]*$", stopping: true, message: "jres:33000678" }), //RC 33000678 : Název položky nesmí obsahovat žádné speciální znaky. 
                                this.createValidatorUnique()
                            ]
                        }
                    }
                })
                .addTextColumn({
                    name: "xml_xpath",
                    caption: "jres:33000675", //RC 33000675 : Cesta Xpath
                    width: 360,
                    editor: {
                        widget: "gstringbox",
                        options: {
                            validators: [new Gordic.Validators.Required({ stopping: true })]
                        }
                    }
                })
            if (this.povolPevnaHodnota == true) {
                gf.addTextColumn({
                    name: "pevna_hodnota",
                    caption: "jres:33000794", //RC 33000794 : Pevná hodnota
                    width: 360,
                    editor: {
                        widget: "gstringbox",
                        options: $.extend(Gordic.Prefabs.Field.charCounter(1000), {

                        })
                    }
                })
            }
                gf.addTextColumn({
                    name: "ukaz_hodnota",
                    width: 120,
                    caption: "jres:33000676" //RC 33000676 : Ukázková hodnota
                })
            return gf;
        }

        private addPolozkaFormulare() {
            this.gridPolozkyFormulare.ggridroweditor("addRow");
        }

        private removePolozkaFormulare() {
            var activeRow = this.gridPolozkyFormulare.ggrid("activeRow");
            if (activeRow != null && activeRow != undefined) {
                var view = this.gridPolozkyFormulare.ggrid("getView");
                view.updateData(activeRow, "delete");
                this.gridPolozkyFormulare.ggrid("setData", view);
            }
        }

        private getPolozkyFormulareData(data: Gordic.AdmIsl.Interface.GFormularSkDto) {
            var view = this.gridPolozkyFormulare.ggrid("getView");
            data.polozkyFormulare = view.getDataRows(false, "data").map((item) => ({
                sloupec: item["sloupec"],
                xml_xpath: item["xml_xpath"],
                ukaz_hodnota: item["ukaz_hodnota"],
                pevna_hodnota: item["pevna_hodnota"]
            }));
            if (data.polozkyFormulare == null || data.polozkyFormulare == undefined)
                data.polozkyFormulare = [];
        }

        private createValidatorUnique(): Gordic.Validators.Base {
            return  new Gordic.Validators.Base({
                stopping: true,
                message: "jres:33000677", //RC 33000677 : Položka musí být na formuláři unikátní.
                validate: (value, source) => {
                    var currentData = this.gridPolozkyFormulare.ggrid("getView").getDataRows(false, "data");
                    var polozky = currentData.map((item) => item.sloupec)
                    if (this.editPolozka != -1) {
                        polozky.splice(this.editPolozka, 1);
                    }
                    return polozky.filter(arr => { return arr == value }).length == 0;
                }
            })
        }

        private dialogFileXml() {
            var form = new Gordic.Forms.Form({
                layoutDescriptor: "L1M1S1",
                name: "dialogXmlFile",
                customClass: "dialogXmlFile"
            })
                .addRow("jres:33000743").addField("gfilefield", { //RC 33000743 : XML soubor
                    name: "xmlFile",
                    validators: [
                        new Gordic.Validators.Required({ stopping: true })
                    ],
                    flag: "required",
                    fileUploaded: (ev, fileInfo) => {
                        if (fileInfo.fileInfo.guid)
                            this.guidsXml.push(fileInfo.fileInfo.guid)
                    },
                }).addRow("jres:33000745").addField("gcheck", { //RC 33000745 : Vymazat všechny uložené položky formuláře
                    name: "deleteOld",
                    labelFromRow: "always",
                }) 

            this.cnt.dialogs.simpleForm("jres:33000744", form, null, { //RC 33000744 : XML soubor
                height: 250,
                width: 500,
                commandBar: [
                    {
                        action: this.cnt.actions.actGetDataFromXmlOk,
                        favorite: true,
                        primary: true
                    },
                    {
                        action: this.cnt.actions.actCloseDialog
                    }
                ]
            }) 
        }

        private dialogFileXmlOk(ev) {
            var cnt = $.content(ev.target);
            var form = cnt.findForms("dialogXmlFile")
            if (form.gform("isValid")) {
                var file = form.findFields("xmlFile").gfield("getValue");
                var deleteOld = form.findFields("deleteOld").gfield("getValue")
                cnt.beginOperation();
                this.getSrv().call<Gordic.AdmIsl.Interface.GFormularPolozkaDto[]>("GetXmlPaths", { guid: file[0].guid }).done((result) => {
                    this.setPolozkyToGrid(result, deleteOld);
                    cnt.close();
                }).always(() => {
                    cnt.endOperation()
                })
            }
        }

        private getDataFromXmlEmpty() {
            this.cnt.dialogs.confirm("jres:33000257", "jres:33000751").on("yes", () => { //RC 33000751 : Přejete si smazat již mapované položky? 
                this.getDataFromXmlEmptyOk(true)
            }).on("no", () => {
                this.getDataFromXmlEmptyOk(false)
            }) 
        }

        private getDataFromXmlEmptyOk(deleteOld: boolean) {
            this.cnt.beginOperation();
            this.getSrv().call("GetXmlPathsEmpty", { ixb: this.data.ixb_xml_edoc }).done((result) => {
                this.setPolozkyToGrid(result, deleteOld);
            }).always(() => { this.cnt.endOperation() })
        }

        private setPolozkyToGrid(polozky: Gordic.AdmIsl.Interface.GFormularPolozkaDto[], deleteOld: boolean) {
            var existPaths: string[] = []
            if (deleteOld == true)
                this.data.polozkyFormulare = [];
            polozky.forEach((item) => {
                var indexPath = this.data.polozkyFormulare?.findIndex((itemPolozka) => itemPolozka.xml_xpath == item.xml_xpath)
                if (indexPath != -1) {
                    if (item.xml_xpath)
                        existPaths.push(item.xml_xpath);
                } else {
                    var index = 2;
                    var polozka = item.sloupec;
                    do {
                        var indexPolozka = this.data.polozkyFormulare?.findIndex((itemPolozka) => itemPolozka.sloupec == polozka)
                        if (indexPolozka != -1)
                            polozka = "{0}{1}".format(item.sloupec?.toString(), index);
                        else
                            item.sloupec = polozka;
                        index++;
                    } while (indexPolozka != -1)
                    this.data.polozkyFormulare?.push(item);
                }
            })
            if (this.data.polozkyFormulare)
                this.gridPolozkyFormulare.ggrid("setData", this.data.polozkyFormulare)
            if (existPaths.length > 0) {
                var existPathsHtml = "<ul>";
                existPaths.forEach((item) => {
                    existPathsHtml += "<li>{0}</li>".format(item);
                })
                existPathsHtml += "</ul>";
                this.cnt.dialogs.warning("jres:32000149", "jres:33000748".format(existPathsHtml)) //RC 33000748 : Následující cesty xml nebyly přidány, protože již existují: <br /> {0}
            }
        }

        // TAB Soubory

        private formSettings() {
            let form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1", customClass: "settings-form", name: "settings-form" })
                .addRow().addField("gcheck", {
                    label: "jres:33000979", //RC 33000979 : Defaultní přípony 
                    name: "default-ext",
                    change: (ev, ctx) => {
                        $(".settings-form").findFields("povol-extension").gfield(ctx.value == true ? "disable" : "enable");
                    }
                })
                .addRow("jres:33000978").addField("gstringbox", { //RC 33000978 : Povolené přípony souborů
                    name: "povol-extension",
                    initialValue: this.getCurrentFormExtensions()
                }) 

            this.cnt.dialogs.simpleForm("jres:33000977", form, null, { width: 400, height: 280 }).on("ok", (ev, data) => {
                 this.cnt.userSettings?.set("povolExt", data["povol-extension"] && (data["default-ext"] == false) ? data["povol-extension"] : ".xml,.xslt,.html,.dct,.xsd,.xsl")
            })
        }

        private getCurrentFormExtensions(): string {
            let current = this.cnt.userSettings?.get("povolExt");
            if (current == null || current == undefined) {
                this.cnt.userSettings?.set("povolExt", ".xml,.xslt,.html,.dct,.xsd,.xsl");
                return ".xml,.xslt,.html,.dct,.xsd,.xsl";
            }
            return current;
        }

        private createFormFiles(tab) {
            var form = new Gordic.Forms.Form({
                layoutDescriptor: "L1M1S1, L-4-6-2, M-6-5-1, S-12-12-0",
                name: "file-fields",
                customClass: "file-fields"
            })
            var index = 0;
            var _this = this;
            this.fieldsData.forEach((field) => {
                form.addRow((field.caption) ? field.caption : "jres:32000154").addField("gstringbox", "w-8", {
                    name: "{0}".format((field.modelValue) ? field.modelValue : 'file-field'),
                    disabled: true
                }).addField("gbuttonpanel", "w-4", {
                    params: [
                        {
                            type: "action",
                            actionContext: {
                                index: index
                            },
                            action: this.cnt.actions.actDeleteFromField
                        },
                        {
                            type: "action",
                            actionContext: {
                                extension: field.allowExtension,
                                title: field.caption,
                                index: index
                            },
                            action: this.cnt.actions.actOpenDetailFile
                        },
                        {
                            type: "action",
                            actionContext: {
                                index: index
                            },
                            action: this.cnt.actions.actDownloadFile
                        },
                        {
                            type: "action",
                            actionContext: {
                                index: index
                            },
                            action: this.cnt.actions.actUpsvEmptyField
                        }
                    ]
                })
                index++;
            })
            $("<div>").appendTo(tab).gform("createFrom", form);
        }

        private openDialogFile(ctx: any) {
            var _this = this;
            $.Deferred(function () {
                var def = this;
                var findedValue = null;
                var modelValue = _this.fieldsData[ctx.index].modelValue
                if (modelValue != null && modelValue != undefined)
                    findedValue = _this.data[modelValue];
                def.resolve(findedValue);
            }).then((obj) => {
                this.getSrv().call("GetFileFromEle", { ixb: obj == undefined ? null : obj }).done((fileInfo) => {
                    var form = new Gordic.Forms.Form()
                        .addRow("jres:32000154").addField("gfilefield", {
                            name: "file-sk-formular",
                            acceptExtension: this.getCurrentFormExtensions(),
                            //acceptExtension: (this.fieldsData[ctx.index].allowExtension) ? this.fieldsData[ctx.index].allowExtension as any : "",
                            maxFileCount: 1,
                            fileUploaded: (ev, fileInfo) => {
                                if (fileInfo.fileInfo.guid) {
                                    this.guids.push(fileInfo.fileInfo.guid)
                                    this.fieldsData[ctx.index].changeValue = true;
                                    this.fieldsData[ctx.index].guid = fileInfo.fileInfo.guid;
                                    this.fieldsData[ctx.index].filename = fileInfo.fileInfo.filename;
                                }
                            },
                            fileRemoved: (ev, fileInfo) => {
                                this.fieldsData[ctx.index].changeValue = true;
                                this.fieldsData[ctx.index].guid = null;
                                this.fieldsData[ctx.index].newValue = null;
                            }
                        })
                    this.cnt.dialogs.simpleForm(ctx.title, form, {}, {
                        height: 200,
                        width: 450,
                        open: (ev, ctx) => {
                            if (ev.target != null) {
                                var cnt = $((ev.target as any).children[0]);
                                setTimeout(() => {
                                    if (fileInfo.guid != null) {
                                        cnt.findFields("file-sk-formular").gfield("setValue", fileInfo);
                                        this.guids.push(fileInfo.guid)
                                    }
                                }, 500);
                            }
                        }
                    }).on("ok", (ev, ctx2) => {
                        if (this.fieldsData[ctx.index].changeValue == true) {
                            var modelValue = this.fieldsData[ctx.index].modelValue;
                            var oldValue = this.cnt.element.findFields("{0}".format(modelValue ? modelValue : "")).gfield("getValue");
                            if (oldValue != null && oldValue != undefined && oldValue != "")
                                this.oldIxsUlo.push(oldValue);
                            if (this.fieldsData[ctx.index].guid != null) {
                                this.getSrv().call("UploadFile", { file: this.fieldsData[ctx.index] }).done((file) => {
                                    this.newIxsUlo.push(file.newValue);
                                    this.fieldsData[ctx.index] = file;
                                    this.cnt.element.findFields("{0}".format(modelValue ? modelValue : "")).gfield("setValue", file.newValue)
                                })
                            } else {
                                this.cnt.element.findFields("{0}".format(modelValue ? modelValue : "")).gfield("setValue", "");
                            }
                        }
                    })
                })
            })
        }

        private downloadFile(ctx: any) {
            var modelValue = this.fieldsData[ctx.index].modelValue;
            var ixs_file = this.cnt.element.findFields("{0}".format(modelValue ? modelValue : "")).gfield("getValue");
            if (ixs_file != null && ixs_file != undefined && ixs_file != "") {
                this.getSrv().call("GetFileFromEle", { ixb: ixs_file }).done((fileInfo) => {
                    new GFile().download(fileInfo).done(() => {
                        this.guids.push(fileInfo.guid);
                    })
                })
            }
        }

        private removeFile(ctx: any) {
            var modelValue = this.fieldsData[ctx.index].modelValue;
            var name = "{0}".format(modelValue ? modelValue : "");
            var ixsOld = this.cnt.element.findFields(name).gfield("getValue");
            if (ixsOld != null && ixsOld != "" && ixsOld != "UPVSEmpty")
                this.oldIxsUlo.push(ixsOld);
            this.cnt.element.findFields(name).gfield("setValue", "");
            this.fieldsData[ctx.index].changeValue = true;
            this.fieldsData[ctx.index].newValue = "";
        }

        private upsvEmptyFile(ctx: any) {
            let modelValue = this.fieldsData[ctx.index].modelValue;
            let name = `${modelValue}`;
            var ixsOld = this.cnt.element.findFields(name).gfield("getValue");
            if (ixsOld != null && ixsOld != "" && ixsOld != "UPVSEmpty")
                this.oldIxsUlo.push(ixsOld);
            this.cnt.element.findFields(name).gfield("setValue", "UPVSEmpty");
            this.fieldsData[ctx.index].changeValue = true;
            this.fieldsData[ctx.index].newValue = "";
        }

        private getDataFromFields(dto: Gordic.AdmIsl.Interface.GFormularSkDto) {
            this.cnt.findForms("file-fields").findFields().gfield("model", "collect", dto);
        }
    }
}